var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBonuses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3337 14V16C29.3337 22.2854 29.3337 25.4281 27.381 27.3807C25.4284 29.3333 22.2857 29.3333 16.0003 29.3333C9.71493 29.3333 6.57224 29.3333 4.61961 27.3807C2.66699 25.4281 2.66699 22.2854 2.66699 16C2.66699 9.71461 2.66699 6.57191 4.61961 4.61929C6.57224 2.66667 9.71493 2.66667 16.0003 2.66667H18.0003",
    stroke: "#FCFCFC",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.333,
    cy: 6.66667,
    r: 4,
    stroke: "#FCFCFC",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33301 18.6667L12.3902 15.6095C12.9109 15.0888 13.7551 15.0888 14.2758 15.6095L16.3902 17.7239C16.9109 18.2446 17.7551 18.2446 18.2758 17.7239L22.6663 13.3333M22.6663 13.3333V16.6667M22.6663 13.3333H19.333",
    stroke: "#FCFCFC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBonuses);
export default __webpack_public_path__ + "static/media/bonuses.a7f00f774c8fc21dea62cb259448b660.svg";
export { ForwardRef as ReactComponent };